import React from "react";
import { useIntl } from "react-intl";
import { Button, Fade, InputBase, Modal, Paper } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import styled from "@emotion/styled";
import { connectHits } from "react-instantsearch-dom";
import CustomHitsBox from "./CustomHitsBox";

const ConnectecHitsBox = connectHits(CustomHitsBox);

const PaperModal = styled(Paper)({
	position: 'absolute',
	border: "0",
  top: '10%',
  left: '10%',
	width: '80%',
  boxShadow: '24',
})

const TextFieldButton = styled(Button)({
	color: "black",
	textTransform: "none"
})

const TextFieldModal = styled(InputBase)({
	height: '72px',
	fontSize: '24px',
})

const DivSearch = styled('div')({
  position: "absolute",
  bottom: "21px",
  right: "134px",
  width: "110px",
  borderBottom: "1px solid #8a8a87"
})

const CustomSearchBox = ({currentRefinement, refine, handleClick}) => {
  const intl = useIntl();
	const [showHits, setShowHits] = React.useState(false);
	const closeWhenClick = (hit, type) => {
		console.log("appel", type)
		setShowHits(false);
		if (typeof handleClick == 'function' && type === 'click')
			handleClick(hit);
	}
  return (
		<>
			<Modal
				open={Boolean(showHits)}
				onClose={()=>setShowHits(false)}
				style={{
					zIndex: "12000"
				}}
			>
				<Fade
					timeout={1000}
					in={Boolean(showHits)}
					mountOnEnter
					unmountOnExit
				>
					<PaperModal>
						<Paper elevation={4}>
							<form role='search'>
								<TextFieldModal
									aria-label="search"
									autoFocus
									fullWidth
									inputProps={{
										'aria-label': "search",
										style:{
											height: '72px',
											fontSize: '32px',
										}
									}}
									startAdornment={
										<SearchIcon style={{margin: "0px 10px", fontSize: "35px", color: "grey"}}/>
									}
									value={currentRefinement}
									onChange={(e) => refine(e.currentTarget.value)}
								/>
							</form>
						</Paper>
						<nav aria-label="nav label">
							<ConnectecHitsBox handleClick={closeWhenClick}/>
						</nav>
					</PaperModal>
				</Fade>
			</Modal>
			<DivSearch>
				<TextFieldButton
					onClick={()=>setShowHits(true)}
					endIcon={<SearchIcon/>}
				>
					{intl.formatMessage({ id: "search" })}
				</TextFieldButton>
			</DivSearch>
		</>
  )
}

export default CustomSearchBox